import { z } from 'zod';
import { ID } from '../../utils/codecUtils';

export const deleteEndpoint = (triggerId: ID) => {
  return {
    endpoint: `/triggers/${triggerId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
